import { useApi } from '../api-provider';
import { useConfiguration } from '../context/configuration-context/use-configuration';
export const useCommentHistory = ({ commentId }) => {
    const { resourceId } = useConfiguration();
    const { commentState, fetchInitialHistory, fetchNextHistory } = useApi((state, actions) => ({
        commentState: state.comments[resourceId],
        fetchInitialHistory: actions.fetchInitialHistory,
        fetchNextHistory: actions.fetchNextHistory,
    }));
    return {
        fetchHistory: () => {
            if (commentState?.type === 'READY' && commentId) {
                fetchInitialHistory({ commentId, resourceId });
            }
        },
        fetchNextHistory: () => {
            if (commentState?.type === 'READY' && commentId) {
                fetchNextHistory({ commentId, resourceId });
            }
        },
        getState: () => {
            if (commentState?.type === 'READY' && commentId) {
                const commentHistoryState = commentState.historyById[commentId];
                if (commentHistoryState?.items.length) {
                    return {
                        type: 'READY',
                        items: commentHistoryState.items,
                        cursor: commentHistoryState.nextCursor,
                        isFetchingNext: commentHistoryState?.isPending,
                    };
                }
                if (commentHistoryState?.isPending === true && commentHistoryState.items.length === 0) {
                    return {
                        type: 'INITIAL_FETCH',
                    };
                }
            }
            return { type: 'NOT_READY' };
        },
        getCommentAuthor: () => {
            if (commentState?.type === 'READY' && commentId) {
                const comment = commentState.commentsById[commentId];
                if (comment.type === 'COMMENT_READY' || comment.type === 'REPLY_READY') {
                    return comment.comment.author?.authorName;
                }
            }
        },
    };
};
//# sourceMappingURL=use-comment-history.js.map